module.exports = __webpack_public_path__ + "img/1584723873.04784c54.jpg";